/**
 * @desc 分页
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.IPage<defs.basics.CorpsInfoResponseDto>>;
export function request(
  params: API.basics.corpsInfo.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/corpsInfo/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
